import React from 'react';
import Section from './Section';
import { motion } from 'framer-motion';

// We will use the hero image later when we successfully move it.
// For now, let's setup the typography.

const Hero = () => {
  return (
    <Section id="hero" className="hero-section">
      <div style={{
        textAlign: 'center',
        padding: '0 2rem',
        zIndex: 10
      }}>
        <motion.h1 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{
            fontSize: 'clamp(3rem, 10vw, 8rem)',
            color: 'var(--text-color)',
            marginBottom: '1rem',
            lineHeight: 1
          }}
        >
          Sonam Sherpa
        </motion.h1>
        <motion.p
           initial={{ opacity: 0 }}
           animate={{ opacity: 1 }}
           transition={{ duration: 1, delay: 1 }}
           style={{
             fontSize: '1.2rem',
             letterSpacing: '0.1em',
             fontFamily: "'Inter', sans-serif"
           }}
        >
          PHOTOGRAPHER & EXPLORER
        </motion.p>
      </div>
      
      {/* Scroll Indicator */}
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        style={{
          position: 'absolute',
          bottom: '2rem',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '0.8rem',
          opacity: 0.7
        }}
      >
        SCROLL
      </motion.div>
    </Section>
  );
};

export default Hero;
